import { watchPosition } from '../modules/GPS';
import { getDistanceBetweenTwoLatLng } from 'modules/Utils';

let watchingPosition = false;

/** @type {undefined | {coords:{latitude: number; longitude: number;}}} */
let currentPosition;

// check spot is in radius
window.checkCurrentLocationIsWithinMeters = (spotId) => {
  const spot = window.Gdata.CurrentSpots.dic[spotId];
  const map = window.Gdata.CurrentMap.ori[0];

  if (
    (MapClass.template.aliasMap !== map.template_id && // not alias map
    MapClass.template.spotCollectionMap !== map.template_id) || // not spot map
    spot.message_board_enabled === true || // is message board
    map.session_account_id === map.account_id // is map owner
  ) {
    return true;
  }

  if (!currentPosition) {
    return false;
  }

  const meters = getDistanceBetweenTwoLatLng(
    currentPosition.coords.latitude,
    currentPosition.coords.longitude,
    spot.latitude || 0,
    spot.longitude || 0
  );
  return meters <= (spot.check_in_limit_meter || 0);
};

window.aliasMapCanCheckIn = (spotId) => {
  const spot = window.Gdata.CurrentSpots.dic[spotId];
  const map = window.Gdata.CurrentMap.ori[0];

  if (
    (MapClass.template.aliasMap !== map.template_id && // not alias map
    MapClass.template.spotCollectionMap !== map.template_id) || // not spot map
    spot.message_board_enabled === true // メッセージボードはGPS確認しない
  ) {
    return true;
  }

  const isDuringEvent = window.MapUtils.isAliasMapDuringEvent(map);
  const isDuringAfterPlay = window.MapUtils.isAliasMapDuringAfterPlay(map);

  if (!isDuringEvent && !isDuringAfterPlay) {
    // $('html').addClass('blockCheckIn');
    return false;
  }
  // $('html').removeClass('blockCheckIn');

  if (!currentPosition) {
    return false;
  }

  // check GPS
  const meters = getDistanceBetweenTwoLatLng(
    currentPosition.coords.latitude,
    currentPosition.coords.longitude,
    spot.latitude || 0,
    spot.longitude || 0
  );

  return meters <= (spot.check_in_limit_meter || 0);
};

// check teams can check in
const handleTeamsCheckIn = async () => {
  const map = window.Gdata.CurrentMap.ori[0];
  if (map.session_account_id === map.account_id) {
    // is map owner
    return;
  }
  if (map.template_id !== MapClass.template.aliasMap && map.template_id !== MapClass.template.spotCollectionMap) {
    // not alias map
    return;
  }

  // ====================
  if (!watchingPosition) {
    watchingPosition = true;
    watchPosition((obj) => {
      currentPosition = obj;
      handleTeamsCheckIn();
    });
  }

  $('.doSNSCheck').each((_, elm) => {
    if (window.aliasMapCanCheckIn($(elm).data('spotid'))) {
      $(elm).removeClass('disabled');
    } else {
      $(elm).addClass('disabled');
    }
  });
};

handleTeamsCheckIn();

// mission
$(document).on('click', '.doMission', (e) => {
  if ($(e.currentTarget).hasClass('disabled')) {
    return;
  }

  window.location.href = '/scan-mission/';
});

window.checkCanDoMission = () => {
  $('.doMission').each((id, elm) => {
    const spot = window.Gdata.CurrentSpots.dic[$(elm).data('spotid')];
    if (!spot) {
      return;
    }
    if (window.SpotUtils.isDuringMission(spot, window.Gdata.CurrentMap.ori[0]).result || window.MapUtils.isMapOwner()) {
      $(elm).parent().removeClass('disableMisson');
    } else {
      $(elm).parent().addClass('disableMisson');
    }
    if (window.checkCurrentLocationIsWithinMeters($(elm).data('spotid'))) {
      $(elm).removeClass('disabled');
    } else {
      $(elm).addClass('disabled');
    }
  });
  $('.showDescriptMission').each((id, elm) => {
    const spot = window.Gdata.CurrentSpots.dic[$(elm).data('spotid')];
    if (!spot) {
      return;
    }

    if (window.SpotUtils.isDuringMission(spot, window.Gdata.CurrentMap.ori[0]).result) {
      $(elm).removeClass('disableMisson');
    } else {
      $(elm).addClass('disableMisson');
    }
  });
};

setInterval(() => {
  window.checkCanDoMission();
}, 10000);

// show TOP button
if (
  window.MapUtils.isCurrentMapAlias() &&
  window.MapUtils.isSessionUserInMapGroup()
) {
  $('#sideMenuTopLink').removeClass('hidden');
}
